(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2026-ces-template"] && !Shopify.designMode) return;
  try {
    
  class ScrollScaleWrapper extends HTMLElement {
    constructor() {
      super();
      this.rafId = null;
      this.handleScroll = this.handleScroll.bind(this);
      this.updateScale = this.updateScale.bind(this);
    }

    connectedCallback() {

// 创建 Intersection Observer 来优化性能
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isActive = true;
            this.updateScale();
          } else {
            this.isActive = false;
          }
        });
      }, {
        root: null,
        rootMargin: '20% 0px',
        threshold: 0
      });

      this.observer.observe(this);
      window.addEventListener('scroll', this.handleScroll, {passive: true});

// 初始化计算
      this.updateScale();
    }

    disconnectedCallback() {
      if (this.observer) 
        this.observer.disconnect();
      


      window.removeEventListener('scroll', this.handleScroll);
      if (this.rafId) 
        cancelAnimationFrame(this.rafId);
      


    }

    handleScroll() {
      if (!this.isActive || this.rafId) return;
      


      this.rafId = requestAnimationFrame(() => {
        this.updateScale();
        this.rafId = null;
      });
    }

    updateScale() {
      const rect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight;

// 计算元素顶部在视口中的位置
      const elementTop = rect.top;
      const viewportPosition = elementTop / windowHeight;

      const startPosition = 0.9;
      const endPosition = 0.2;
      const minScale = 0.8;
      const maxScale = 1.0;

      let scale;

      if (viewportPosition >= startPosition) {
        scale = minScale;
      } else if (viewportPosition <= endPosition) {
        scale = maxScale;
      } else {
        const progress = (startPosition - viewportPosition) / (startPosition - endPosition);
        scale = minScale + (maxScale - minScale) * progress;
      }

// 应用缩放变换到第一个子元素（通常是包裹的内容）
      if (this.firstElementChild) {
        this.firstElementChild.style.transform = `scale(${scale})`;
        this.firstElementChild.style.willChange = 'transform';

// Removed transition to avoid conflict with GSAP/ScrollTrigger updates
// this.firstElementChild.style.transition = 'transform 0.1s linear';
      }
    }
  }

  customElements.define('scroll-scale-wrapper', ScrollScaleWrapper);

// Nasync Accordion Logic
  document.addEventListener('DOMContentLoaded', () => {

// Refresh ScrollTrigger after a short delay to allow custom elements to settle
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 100);

    // Initialize Swiper for Panelists on Mobile Only
    let panelistsSwiper = null;

    function initPanelistsSwiper() {
      if (window.innerWidth <= 768) {
        if (!panelistsSwiper) {
          panelistsSwiper = new Swiper('.panelists-content', {
            slidesPerView: 1.4,
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            pagination: {
              el: '.panelists-content .swiper-pagination-fraction',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.panelists-content .swiper-button-next',
              prevEl: '.panelists-content .swiper-button-prev'
            }
          });
        }
      } else {
        if (panelistsSwiper) {
          panelistsSwiper.destroy(true, true);
          panelistsSwiper = null;
        }
      }
    }

    initPanelistsSwiper();
    window.addEventListener('resize', initPanelistsSwiper);

    const accordionItems = document.querySelectorAll('.nasync-right-item');

// Helper function to handle the click
    const handleClick = (clickedItem) => {

// If clicked item is already active, do nothing (or toggle if you prefer)
      if (clickedItem.classList.contains('active')) return;
      


      accordionItems.forEach(item => {
        if (item === clickedItem) { // Open the clicked item
          item.classList.add('active');
        } else { // Close other items
          item.classList.remove('active');
        }
      });
    };

    accordionItems.forEach(item => {
      item.addEventListener('click', () => handleClick(item));
    });

// GSAP Scroll Logic
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);

  function initCesVideoSection(section) {
      if (!section) return;

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const container = entry.target.querySelector('.ug-index-section-brand-power__video');
          if (!container) return;

          const player = container.querySelector('ug-video-player');
          const video = container.querySelector('video');

          if (entry.isIntersecting) {
            // Logic handled by specific observer in initVideoSection
             /* if (player) {
               if (typeof player.loadVideo === 'function') player.loadVideo();
               if (typeof player.playVideo === 'function') player.playVideo();
             } else if (video) {
               video.play().catch(() => {});
             } */
          } else {
             if (player) {
               if (typeof player.pauseVideo === 'function') player.pauseVideo();
             } else if (video) {
               video.pause();
             }
          }
        });
      }, { rootMargin: "0px", threshold: 0.1 });
      
      videoObserver.observe(section);
  }

  // Helper function for throttling
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  // 0. Initialize Video Section
  const videoSection = document.querySelector(".ces-video-section");
  if (videoSection) {
     initVideoSection(videoSection); // Restore scaling effect
     initCesVideoSection(videoSection); // Keep intersection observer for playback
  }

  // 3. Initialize Subscribe Bar Logic
  const subscribeBar = document.querySelector('.ces-subscribe-bar');
  const bannerSection = document.querySelector('.ces-banner-section');
  const footerSection = document.querySelector('footer') || document.querySelector('#shopify-section-footer');
  
  if (subscribeBar && bannerSection) {
    let ticking = false;
    
    const updatePosition = () => {
      const targetSection = videoSection || bannerSection;
      const targetRect = targetSection.getBoundingClientRect();
      // Show bar when target section bottom is out of view (scrolled past)
      if (targetRect.bottom < 0) {
        subscribeBar.classList.add('is-visible');
      } else {
        subscribeBar.classList.remove('is-visible');
      }

      if (footerSection) {
        const footerRect = footerSection.getBoundingClientRect();
        
        // Check if footer is entering the viewport
        if (footerRect.top < window.innerHeight) {
           subscribeBar.classList.add('is-absolute');
           subscribeBar.style.position = 'absolute';
           subscribeBar.style.bottom = `${footerSection.offsetHeight}px`; // Place exactly on top of footer
           subscribeBar.style.top = 'auto';
           const footerOffsetTop = footerSection.offsetTop;
           const barHeight = subscribeBar.offsetHeight;
           
           subscribeBar.style.position = 'absolute';
           subscribeBar.style.bottom = 'auto';
           subscribeBar.style.left = '0';
           subscribeBar.style.top = `${footerOffsetTop - barHeight}px`;
           subscribeBar.style.transform = 'none';
           subscribeBar.style.transition = 'none';
           
        } else {
           // Restore fixed positioning
           subscribeBar.style.position = 'fixed';
           subscribeBar.style.bottom = '0';
           subscribeBar.style.top = 'auto';
           subscribeBar.style.left = '0';
           subscribeBar.style.transform = '';
           subscribeBar.style.transition = '';
           subscribeBar.classList.remove('is-absolute');
        }
      }
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updatePosition);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    updatePosition(); // Initial check

    // Handle Click
    const subBtn = subscribeBar.querySelector('.subscribe-bar-right');
    if (subBtn) {
      subBtn.addEventListener('click', () => {
        // Scroll directly to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
      // 4. Initialize CES Subscribe Form
  const subscribeForm = document.querySelector('.ces-subscribe-form');
  if (subscribeForm) {
    const emailInput = subscribeForm.querySelector('.ces-subscribe-input');
    const checkboxInput = subscribeForm.querySelector('.ces-checkbox-input');
    const submitBtn = subscribeForm.querySelector('.ces-subscribe-btn');
    const successMsg = document.querySelector('.ces-message-success');
    const errorMsg = document.querySelector('.ces-message-error');

    subscribeForm.addEventListener('submit', function(e) {
      e.preventDefault();

      // Prevent duplicate submission
      if (submitBtn.classList.contains('loading')) {
        return false;
      }

      // Clear previous messages
      if (successMsg) {
        successMsg.innerHTML = '';
        successMsg.style.display = 'none';
      }
      if (errorMsg) {
        errorMsg.innerHTML = '';
        errorMsg.style.display = 'none';
      }

      // Validate email presence
      if (!emailInput.value || !emailInput.value.trim()) {
        if (errorMsg) {
          errorMsg.innerHTML = 'Please enter your email address.';
          errorMsg.style.display = 'block';
        }
        return false;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value)) {
        if (errorMsg) {
          errorMsg.innerHTML = 'Please enter a valid email address.';
          errorMsg.style.display = 'block';
        }
        return false;
      }

      // Validate checkbox
      if (checkboxInput && !checkboxInput.checked) {
        if (errorMsg) {
          errorMsg.innerHTML = 'Please agree to the Terms of Use and Privacy Policy.';
          errorMsg.style.display = 'block';
        }
        return false;
      }

      // Add loading state
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      const originalBtnText = submitBtn.textContent;
      submitBtn.textContent = 'Submitting...';

      // Submit form
      fetch('https://ecf.cirkleinc.com/api/form-submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailInput.value.trim(),
          accepts_marketing: checkboxInput && checkboxInput.checked ? 'on' : 'off',
          form_id: 'c6d1b6ef-4d03-4281-9c95-e19f6ede9741',
        }),
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          emailInput.value = '';
          if (checkboxInput) checkboxInput.checked = false;
          if (successMsg) {
            successMsg.innerHTML = 'Thank you for subscribing!';
            successMsg.style.display = 'block';
          }

          if (window.ugGa4Track) {
            window.ugGa4Track.subscriptionEvent({
              isSuccess: true,
              position: 'ces-banner',
            });
          }
        } else {
          const errorText = data?.errors?.email?.[0] || data.message || 'Something went wrong. Please try again.';
          if (errorMsg) {
            errorMsg.innerHTML = errorText;
            errorMsg.style.display = 'block';
          }

          if (window.ugGa4Track) {
            window.ugGa4Track.subscriptionEvent({
              isSuccess: false,
              position: 'ces-banner',
            });
          }
        }
      })
      .catch((error) => {
        if (errorMsg) {
          errorMsg.innerHTML = 'Network error. Please try again later.';
          errorMsg.style.display = 'block';
        }
        console.error('Subscription Error:', error);

        if (window.ugGa4Track) {
          window.ugGa4Track.subscriptionEvent({
            isSuccess: false,
            position: 'ces-banner',
          });
        }
      })
      .finally(() => {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
      });
    });
  }

  function initCesEventHighlights() {
    const swiperEl = document.querySelector('.event-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const isPC = window.innerWidth > 768;
    const navigation = document.querySelector('.ces-event-highlights-section .swiper-navigation');
    const targetLoop = !isPC;

    // Destroy existing swiper if loop mode needs to change between PC and Mobile
    if (swiperEl.swiper) {
      if (swiperEl.swiper.params.loop !== targetLoop) {
        swiperEl.swiper.destroy(true, true);
      } else {
        return;
      }
    }

    // If PC and slides <= 3, don't init swiper
    if (isPC && slideCount <= 3) {
        if (navigation) navigation.style.display = 'none';
        return;
    }

    const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        centeredSlides: false,
        navigation: {
          nextEl: '.ces-event-highlights-section .swiper-button-next',
          prevEl: '.ces-event-highlights-section .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3.2,
            spaceBetween: 20,
            centeredSlides: true,
            centeredSlidesBounds: true,
            loop: false, // Breakpoints won't actually change this, handled by destruction logic above
            watchSlidesProgress: true,
          }
        }
    });

    if (navigation) {
        navigation.style.display = (isPC && slideCount > 3) ? 'flex' : 'none';
    }

    // Lightbox Logic using event delegation to support looped/cloned slides
    const lightbox = document.querySelector('.ces-image-lightbox');
    const lightboxImg = lightbox ? lightbox.querySelector('img') : null;
    const closeBtn = lightbox ? lightbox.querySelector('.lightbox-close') : null;

    if (lightbox && lightboxImg) {
      // Use event delegation on swiperEl
      const handleImageClick = (e) => {
        const img = e.target.closest('.swiper-slide img');
        if (img) {
          const src = img.getAttribute('src');
          lightboxImg.src = src;
          lightbox.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      };

      // Clean up old listener if any and add new one
      swiperEl.removeEventListener('click', swiperEl._lightboxHandler);
      swiperEl._lightboxHandler = handleImageClick;
      swiperEl.addEventListener('click', handleImageClick);

      // Close Lightbox function
      const closeLightbox = () => {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(() => { lightboxImg.src = ''; }, 300);
      };

      if (closeBtn) closeBtn.onclick = closeLightbox;
      lightbox.onclick = (e) => { if (e.target === lightbox) closeLightbox(); };

      // Global Escape key
      if (!window._lightboxKeydownBound) {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
             const activeLightbox = document.querySelector('.ces-image-lightbox.active');
             if (activeLightbox) {
                activeLightbox.classList.remove('active');
                document.body.style.overflow = '';
             }
          }
        });
        window._lightboxKeydownBound = true;
      }
    }
  }

  function initCesNewroom() {
    const swiperEl = document.querySelector('.newroom-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const isPC = window.innerWidth > 768;
    const navigation = document.querySelector('.ces-newroom-section .swiper-navigation');

    // If not PC or slides <= 3 on PC, don't use swiper
    if (!isPC || (isPC && slideCount <= 3)) {
        if (swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
        }
        if (navigation) navigation.style.display = 'none';
        return;
    }

    // Don't re-init if already swiper
    if (swiperEl.swiper) return;

    const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        centeredSlides: false,
        navigation: {
          nextEl: '.ces-newroom-section .swiper-button-next',
          prevEl: '.ces-newroom-section .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: true,
            centeredSlidesBounds: true,
            loop: false,
            watchSlidesProgress: true,
          }
        }
    });

    if (navigation) {
        navigation.style.display = slideCount > 3 ? 'flex' : 'none';
    }
      
      // Lightbox Logic
      const lightbox = document.querySelector('.ces-image-lightbox');
      const lightboxImg = lightbox.querySelector('img');
      const closeBtn = lightbox.querySelector('.lightbox-close');
      
      if (lightbox && lightboxImg) {
        // Open Lightbox
        swiperEl.querySelectorAll('.swiper-slide img').forEach(img => {
          img.style.cursor = 'zoom-in';
          img.addEventListener('click', () => {
             const src = img.getAttribute('src');
             lightboxImg.src = src;
             lightbox.classList.add('active');
             document.body.style.overflow = 'hidden'; // Prevent scrolling
          });
        });
        
        // Close Lightbox function
        const closeLightbox = () => {
          lightbox.classList.remove('active');
          document.body.style.overflow = '';
          setTimeout(() => { lightboxImg.src = ''; }, 300); // Clear src after transition
        };

        // Close on button click
        if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
        
        // Close on background click
        lightbox.addEventListener('click', (e) => {
           if (e.target === lightbox) closeLightbox();
        });
        
        // Close on Escape key
        document.addEventListener('keydown', (e) => {
           if (e.key === 'Escape' && lightbox.classList.contains('active')) closeLightbox();
        });
      }
  }

  // Initialize only if corresponding elements exist in DOM
  const handleCesSwipers = () => {
    if (document.querySelector('.event-swiper')) initCesEventHighlights();
    if (document.querySelector('.newroom-swiper')) initCesNewroom();
  };

  handleCesSwipers();
  window.addEventListener('resize', handleCesSwipers);

  // 1. Initialize Highlights Section
   const highlightSection = document.querySelector(".ces-highlights-section");
   if (highlightSection) {
        if (window.matchMedia('(max-width: 768px)').matches) {
          if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll().forEach(st => {
              const trg = st.trigger;
              if (trg && highlightSection.contains(trg)) 
                st.kill(true);
              

            });
          }
          const listEl = highlightSection.querySelector('.ces-highlight-list');
          if (listEl) {
            listEl.style.transform = '';
            listEl.style.willChange = '';
          }
          highlightSection.style.position = '';
          highlightSection.style.overflow = '';
        } else {
          initHighlightsSection(highlightSection);
        }
      }

// 2. Initialize Series Section
      const seriesSection = document.querySelector('.ces-series-section');
      if (seriesSection) {
        const cleanupSeries = () => {
          if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.getAll().forEach(st => {
              if (st && st.vars && st.vars.trigger === seriesSection) 
                st.kill();
              

            });
          }
          seriesSection.querySelectorAll('.series-list').forEach(el => {
            el.style.flexGrow = '';
            el.classList.remove('active');
          });
          seriesSection.querySelectorAll('.series-item').forEach(el => {
            el.style.height = '';
          });
          const players = seriesSection.querySelectorAll('ug-video-player');
          players.forEach(p => {
            try {
              if (typeof p.pauseVideo === 'function') 
                p.pauseVideo();
              

            } catch (e) {}
          });
        };

        const setupSeries = () => {
          const isMb = window.matchMedia('(max-width: 768px)').matches;
          const nextMode = isMb
            ? 'mb'
            : 'pc';
          if (seriesSection.dataset.mode !== nextMode) {
            cleanupSeries();
            seriesSection.dataset.mode = nextMode;
            if (isMb) {
              initSeriesSectionMobile(seriesSection);
            } else {
              initSeriesSection(seriesSection);
            }
          }
        };

        setupSeries();
        window.addEventListener('resize', setupSeries);
      }

// Refresh ScrollTrigger on load to ensure calculations are correct
      window.addEventListener("load", () => {
        ScrollTrigger.refresh();
      });
    }
  });

// Function to handle Video Section Logic
  function initVideoSection(section) {
    const videoWrap = section.querySelector('.ug-index-section-brand-power__video-wrap');
    const videoContent = section.querySelector('.ug-index-section-brand-power__video');
    const controlBtn = section.querySelector('.ces-video-control-btn');

    if (videoContent) {
      gsap.fromTo(videoContent, {scale: 0.8}, {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom", // Start when section top enters viewport bottom
          end: "center center", // End when section center aligns with viewport center
          scrub: 1, // Smooth scrubbing
        }
      });

      // 10s Preview Logic
      const player = videoContent.querySelector('ug-video-player');
      const video = videoContent.querySelector('video');
      let previewPlayed = false;
      let hasAutoPlayed = false; // Flag to ensure auto-play only happens once

      const checkTime = () => {
          if (previewPlayed) return;
          const currentTime = (player && player.currentTime) || (video && video.currentTime) || 0;
          if (currentTime >= 10) {
              if (player && typeof player.pauseVideo === 'function') player.pauseVideo();
              else if (video) video.pause();
              previewPlayed = true; // Only pause once
          } else {
             requestAnimationFrame(checkTime);
          }
      };

      // Intersection Observer to handle auto-play on scroll
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!hasAutoPlayed) {
              hasAutoPlayed = true; // Mark as played so it doesn't auto-play again
              
              if (player && typeof player.playVideo === 'function') {
                player.playVideo();
              } else if (video) {
                video.play().catch(() => {});
              }
              
              // Start checking time to pause after 10s
              requestAnimationFrame(checkTime);
            }
          } else {
             // Pause if scrolled out of view (optional, but good practice)
             if (player && typeof player.pauseVideo === 'function') {
                player.pauseVideo();
             } else if (video) {
                video.pause();
             }
          }
        });
      }, { threshold: 0.5 }); // Trigger when 50% visible

      observer.observe(section);

      // Start checking when video starts playing (fallback)
      if (video) {
          video.addEventListener('play', () => {
              if (!previewPlayed) requestAnimationFrame(checkTime);
          });
      } else if (player) {
           // For ug-video-player, we might need to poll or listen to events if available
           // Assuming it exposes video element or similar event
           const innerVideo = player.querySelector('video');
           if (innerVideo) {
               innerVideo.addEventListener('play', () => {
                   if (!previewPlayed) requestAnimationFrame(checkTime);
               });
           }
      }
      
      // Control Button Logic
      if (controlBtn) {
        controlBtn.addEventListener('click', () => {
           const player = videoContent.querySelector('ug-video-player');
           
           // Force YouTube video for lightbox
           const type = 'youtube';
           const src = 'https://www.youtube.com/embed/P7-X7OJjUQA?autoplay=1';

           if (src) {
               const lightbox = document.querySelector('.ces-video-lightbox');
               const lightboxVideo = lightbox.querySelector('video');
               const lightboxIframe = lightbox.querySelector('iframe');
               const closeBtn = lightbox.querySelector('.lightbox-close');

               if (lightbox) {
                   lightbox.classList.remove('mp4', 'youtube');
                   lightbox.classList.add('active', type);
                   
                   if (type === 'youtube' && lightboxIframe) {
                       lightboxIframe.src = src;
                   } else if (type === 'mp4' && lightboxVideo) {
                       lightboxVideo.style.display = 'none';
                   }

                   document.body.style.overflow = 'hidden';

                   // Pause background video
                   if (player && typeof player.pauseVideo === 'function') {
                      player.pauseVideo();
                   }
                   const bgVideo = videoContent.querySelector('video');
                   if (bgVideo) bgVideo.pause();

                   const closeLightbox = () => {
                       lightbox.classList.remove('active');
                       document.body.style.overflow = '';
                       if (lightboxVideo) {
                           lightboxVideo.pause();
                           lightboxVideo.src = '';
                       }
                       if (lightboxIframe) {
                           lightboxIframe.src = '';
                       }
                   };

                   closeBtn.onclick = closeLightbox;
                   lightbox.onclick = (e) => {
                       if (e.target === lightbox) closeLightbox();
                   };
               }
           }
        });
      }
    }
  }

// Function to handle Highlights Section Logic
  function initHighlightsSection(section) {
    if (window.matchMedia('(max-width: 768px)').matches) return;
    


    const list = section.querySelector(".ces-highlight-list");
    const contentContainer = section.querySelector(".ces-highlights-content");

    if (section && list) { // Ensure the section has a defined layout for pinning
      section.style.overflow = 'hidden';
      section.style.backgroundColor = '#f8f8f8'; // Match CSS
      section.style.position = 'relative';

// Calculate the total distance to scroll horizontally
      function getScrollDistance() {
        let listWidth = list.scrollWidth;
        let contentContainer = section.querySelector('.ces-highlights-content');

// Fallback to window width if container is missing (unlikely)
        let contentWidth = contentContainer
          ? contentContainer.clientWidth
          : window.innerWidth;

// If list is smaller than content area, don't scroll
        if (listWidth <= contentWidth) 
          return 0;
        


// Scroll distance = Total List Width - Content Area Width
// This ensures the right edge of the list stops exactly at the right edge of the content area
        return -(listWidth - contentWidth);
      }

      const tween = gsap.to(list, {
        x: getScrollDistance,
        ease: "none"
      });

      const st = ScrollTrigger.create({
        trigger: section,
        start: "top top", // Pin when the top of the section hits the top of the viewport
        end: () => `+=${
          Math.abs(getScrollDistance())
        }`, // Duration proportional to scroll distance
        pin: true,
        pinSpacing: true, // Ensure space is reserved
        animation: tween,
        scrub: 0.5, // Smooth scrubbing
        anticipatePin: 1, // Prevent jumping on quick entry
        fastScrollEnd: true, // Optimize for fast scrolling
        preventOverlaps: true, // Prevent layout conflicts
        invalidateOnRefresh: true
      });

// Ensure ScrollTrigger refreshes when images inside the section are loaded
// This prevents layout shifts from messing up start/end calculations
      const images = section.querySelectorAll('img');
      let imagesLoaded = 0;

      const onImageLoad = () => {
        imagesLoaded++;
        if (imagesLoaded === images.length) {
          ScrollTrigger.refresh();
        }
      };

      images.forEach(img => {
        if (img.complete) {
          onImageLoad();
        } else {
          img.addEventListener('load', onImageLoad);
          img.addEventListener('error', onImageLoad); // Count errors as loaded to avoid hanging
        }
      });

// IntersectionObserver for child-img fade in/out
      const observerOptions = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.5 // Trigger when 50% visible
      };

      const fadeInObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const childImg = entry.target.querySelector('.child-img');
          if (childImg) {
            if (entry.isIntersecting) { // Fully visible: show image
              childImg.style.opacity = '1';
            } else { // Not fully visible: hide image
              childImg.style.opacity = '0';
            }
          }
        });
      }, observerOptions);

      section.querySelectorAll('.highlight-item-left.has-child-img').forEach(el => {
        fadeInObserver.observe(el);
      });
    }
  }

// Function to handle Series Section Logic
  function getHeaderOffsetValue() {
    var v = parseInt(getComputedStyle(document.body).getPropertyValue('--header-group-height') || '0', 10) || 0;
    if (v > 0) return v;
    

    var hg = document.querySelector('#header-group');
    if (! hg) 
      return 0;
    

    var rect = hg.getBoundingClientRect();
    return Math.max(0, rect.height || 0);
  }
  function initSeriesSection(section) {
    const seriesItems = section.querySelectorAll('.series-list');

    if (section && seriesItems.length > 0) { // Initial State: Remove active from all and pause videos
      seriesItems.forEach(i => {
        i.classList.remove('active');
        handleVideoPlayback(i, false);
      });

      let isInteractionEnabled = false;
      let currentActiveIdx = -1;

      seriesItems.forEach(i => {
        const item = i.querySelector('.series-item');
        if (item) 
          item.style.willChange = 'transform,opacity';
        

        const img = i.querySelector('.series-image');
        if (img) {
          img.style.willChange = 'transform,opacity';
          img.style.transform = 'translateZ(0)';
        }
      });

// 1. Pinning Timeline (controls the pinned duration)
      ScrollTrigger.create({
        trigger: section,
        start: "center center",
        end: "+=1200",
        pin: true,
        pinSpacing: true,
        anticipatePin: 1
      });

// 2. Expansion Timeline (controls the expansion of the NEAREST item)

// Global mouse tracker for this section
      let lastMouseX = window.innerWidth / 2;
      if (!window.__cesSeriesMouseBound) {
        document.addEventListener('mousemove', (e) => {
          lastMouseX = e.clientX;
        });
        window.__cesSeriesMouseBound = true;
      }

      let lastAppliedProgress = -1;
      ScrollTrigger.create({
        trigger: section,
        start: "center center",
        end: "+=900",
        scrub: 0.35,
        preventOverlaps: true,
        fastScrollEnd: true,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const progress = self.progress;
          if (Math.abs(progress - lastAppliedProgress) < 0.01) return;
          

          lastAppliedProgress = progress;

// 1. Calculate nearest item dynamically
          let closest = null;
          let minDistance = Infinity;
          seriesItems.forEach(item => {
            const rect = item.getBoundingClientRect();
            const itemCenter = rect.left + rect.width / 2;
            const distance = Math.abs(lastMouseX - itemCenter);
            if (distance < minDistance) {
              minDistance = distance;
              closest = item;
            }
          });
          const targetItem = closest || seriesItems[0];

// 2. Handle State based on progress
          if (progress >= 0.6) {
            if (! isInteractionEnabled) {
              isInteractionEnabled = true;

// Lock state to the current target
              seriesItems.forEach(item => {
                item.style.flexGrow = ''; // Clear inline styles
                if (item === targetItem) {
                  item.classList.add('active');
                  handleVideoPlayback(item, true);
                  currentActiveIdx = Array.from(seriesItems).indexOf(item);
                } else {
                  item.classList.remove('active');
                  handleVideoPlayback(item, false);
                }
              });
            }
          } else { // Phase: Expanding (Scrubbing)
            if (isInteractionEnabled) {
              isInteractionEnabled = false;

// Reset interaction state when scrolling back
              seriesItems.forEach(i => {
                i.classList.remove('active');
                handleVideoPlayback(i, false);
              });
              currentActiveIdx = -1;
            }

// Dynamic expansion based on mouse position
            seriesItems.forEach(item => {

// Ensure no active class interference
              item.classList.remove('active');

              if (item === targetItem) { // Grow from 0 to 1 based on scroll progress
                item.style.flexGrow = progress;
              } else {
                item.style.flexGrow = 0;
              }
            });
          }
        }
      });

// 3. Hover Interaction Logic (Enabled only after expansion)
      seriesItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          if (! isInteractionEnabled) return;
          


          seriesItems.forEach(i => {
            i.classList.remove('active');
            handleVideoPlayback(i, false);
          });
          item.classList.add('active');
          handleVideoPlayback(item, true);
        });
      });

// Helper to control video playback
      function handleVideoPlayback(item, shouldPlay) {
        const player = item.querySelector('ug-video-player');
        if (player) {
          if (shouldPlay) {
            try {
              if (typeof player.isPlaying === 'function' && player.isPlaying()) return;
              

            } catch (e) {}
            if (typeof player.loadVideo === 'function') 
              player.loadVideo();
            

            if (typeof player.mute === 'function') 
              player.mute();
            

            if (typeof player.playVideo === 'function') 
              player.playVideo();
            

          } else {
            if (typeof player.pauseVideo === 'function') 
              player.pauseVideo();
            

          }
          return;
        }
        const video = item.querySelector('video');
        if (video) {
          if (shouldPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      }
    }
  }

  function initSeriesSectionMobile(section) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
      


      const lists = Array.from(section.querySelectorAll('.series-list'));
      if (lists.length === 0) return;
      


      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const wasInView = window.__seriesMobileInView;
          window.__seriesMobileInView = entry.isIntersecting;
          
          if (!entry.isIntersecting) {
             lists.forEach(l => playVideoIn(l, false));
          } else {
             if (!wasInView) {
               const l = lists[lastExpandedIdx];
               if (l) playVideoIn(l, true);
             }
          }
        });
      }, { rootMargin: "0px", threshold: 0.1 });
      sectionObserver.observe(section);

      const videoUpdateTs = new WeakMap();
      const posterTimeouts = new WeakMap();

      const playVideoIn = (list, shouldPlay) => {
        const now = Date.now();
        const last = videoUpdateTs.get(list) || 0;
        videoUpdateTs.set(list, now);

        const player = list.querySelector('ug-video-player');
        if (player) {
          if (shouldPlay) {
            if (!window.__seriesMobileInView) return;

            if (posterTimeouts.has(list)) {
                clearTimeout(posterTimeouts.get(list));
                posterTimeouts.delete(list);
            }

            try {
              if (typeof player.isPlaying === 'function' && player.isPlaying()) return;
            } catch (e) {}
            
            if (typeof player.loadVideo === 'function') player.loadVideo();
            if (typeof player.mute === 'function') player.mute();
            if (typeof player.playVideo === 'function') player.playVideo();
            
          } else {
            if (posterTimeouts.has(list)) {
                clearTimeout(posterTimeouts.get(list));
                posterTimeouts.delete(list);
            }

            if (typeof player.reset === 'function') {
              try {
                player.reset({unload: false, disableAutoplay: true});
              } catch (e) {}
            } else {
              if (typeof player.pauseVideo === 'function') 
                player.pauseVideo();
            }
            try {
              player.classList.remove('is-playing', 'is-loaded', 'has-started');
            } catch (e) {}

          }
          return;
        }
        const video = list.querySelector('video');
        if (video) {
          if (shouldPlay) {
            if (!window.__seriesMobileInView) return;
            
            try { video.setAttribute('playsinline', ''); } catch (e) {}
            try { video.muted = true; } catch (e) {}
            try { video.style.transform = 'translateZ(0)'; } catch (e) {}
            try { video.style.willChange = 'transform'; } catch (e) {}
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      };

      lists.forEach((list, idx) => {
        const isActive = idx === 0;
        list.classList.toggle('active', isActive);
        playVideoIn(list, false);
      });

      const headerGroup = document.querySelector('#header-group');
      const getHeaderOffset = () => {
        if (! headerGroup) return 60;
        const rect = headerGroup.getBoundingClientRect();
        return Math.max(0, rect.height);
      };

      const collapsedHeightVw = 48;
      const expandedHeightVw = 96;
      const steps = lists.length;

      const listItems = lists.map(list => ({
        list,
        item: list.querySelector('.series-item'),
        img: list.querySelector('.series-image')
      }));

      const targetHeights = new Array(steps).fill(collapsedHeightVw);
      const currentHeights = targetHeights.slice();
      let animRaf = null;
      const animateHeights = () => {
        if (animRaf) return;
        const step = () => {
          let stillAnimating = false;
          listItems.forEach(({item}, i) => {
            if (!item) return;
            const cur = currentHeights[i];
            const tar = targetHeights[i];
            const next = cur + (tar - cur) * 0.25;
            if (Math.abs(next - tar) > 0.1) stillAnimating = true;
            currentHeights[i] = next;
            item.style.height = `${next}vw`;
          });
          if (stillAnimating) {
            animRaf = requestAnimationFrame(step);
          } else {
            animRaf = null;
          }
        };
        animRaf = requestAnimationFrame(step);
      };
      const setHeights = (s, t) => {
        listItems.forEach(({item}, i) => {
          if (!item) return;
          let h = collapsedHeightVw;
          if (s < steps - 1) {
            if (i === s) {
              h = expandedHeightVw - (expandedHeightVw - collapsedHeightVw) * t;
            } else if (i === s + 1) {
              h = collapsedHeightVw + (expandedHeightVw - collapsedHeightVw) * t;
            }
          } else if (i === s) {
            h = expandedHeightVw;
          }
          targetHeights[i] = h;
        });
        animateHeights();
      };

      const switchActive = (prevIdx, nextIdx) => {
        const next = lists[nextIdx];
        lists.forEach((l, i) => {
          const isActive = i === nextIdx;
          l.classList.toggle('active', isActive);
          if (!isActive) playVideoIn(l, false);
        });
        if (next) playVideoIn(next, true);
      };

      setHeights(0, 0);
      
      const firstList = lists[0];
      if (firstList) {
        firstList.classList.add('active');
        playVideoIn(firstList, false); 
      }

      let lastExpandedIdx = 0;
      let lastAppliedProgressMb = -1;
      const triggerEl = section.querySelector('.ces-series-body');
      ScrollTrigger.create({
          trigger: triggerEl || section,
          start: "top 35%",
          end: "bottom 35%",
          scrub: 0.35,
          preventOverlaps: true,
        onEnter: () => {
          window.__seriesMobileInView = true;
          // When entering viewport via scroll, play current active
          const l = lists[lastExpandedIdx];
          if (l) playVideoIn(l, true);
        },
        onUpdate: (self) => {
            const prog = self.progress;
            if (Math.abs(prog - lastAppliedProgressMb) < 0.01) return;
            

            lastAppliedProgressMb = prog;
            const p = self.progress;
            const s = Math.min(steps - 1, Math.floor(p * steps));
            const t = Math.max(0, Math.min(1, p * steps - s));

            setHeights(s, t);

            const expandedIdx = s < steps - 1 ? (t >= 0.6
              ? s + 1
              : s) : steps - 1;
        if (expandedIdx !== lastExpandedIdx) {
          switchActive(lastExpandedIdx, expandedIdx);
          lastExpandedIdx = expandedIdx;
        }
      }, onLeave : () => {
        setHeights(steps - 1, 1);
        switchActive(lastExpandedIdx, steps - 1);
        lastExpandedIdx = steps - 1;
      }, onEnterBack : () => {
        window.__seriesMobileInView = true;
        const l = lists[lastExpandedIdx];
        if (l) playVideoIn(l, true);
      }}
  );

}

  (function() {
    function transparentHeader() {
      const header = document.querySelector('header-component');
      if (header) {
        header.setAttribute('transparent', 'not-sticky');
        header.classList.add('color-scheme-6');
        
        // Define logos
        const logoInverseSrc = "https://us.ugreen.com/cdn/shop/files/ugreen_logo-_1.svg?height=44&v=1761026719"; // White Logo
        const logoOriginalSrc = "https://us.ugreen.com/cdn/shop/files/ugreen_logo-…4509-bd2e-8ea001ac3a12.svg?height=44&v=1761026731"; // Original Black Logo
        
        // Force update logo logic
        const updateLogo = () => {
          const logoImg = header.querySelector('.header-logo__image-container--original img');
          if (logoImg) {
            // If header is transparent (not sticky), use Inverse Logo
            if (header.getAttribute('transparent') === 'not-sticky') {
               logoImg.srcset = logoInverseSrc;
               logoImg.src = logoInverseSrc;
            } else {
               // Sticky/Scrolled state, use Original Logo
               logoImg.srcset = logoOriginalSrc;
               logoImg.src = logoOriginalSrc;
            }
          }
        };

        // Initial update
        updateLogo();

        // Observe attribute changes on header to switch logo dynamically
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'transparent') {
              updateLogo();
            }
          });
        });

        observer.observe(header, { attributes: true });
      }
    }

    function initTitleAnimation() {
      const titleElements = document.querySelectorAll('[data-animated="title"]');
      
      if (titleElements.length === 0) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ug-animated-title');
          } else {
            entry.target.classList.remove('ug-animated-title');
          }
        });
      }, { threshold: 0.1 });

      titleElements.forEach(element => observer.observe(element));
    }

    function init() {
      transparentHeader();
      initTitleAnimation();
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ramadan-gift-box"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
    window.__ramadanSceneInView = false;
    // Influencer data
    const influencerData = [
      {
        name: 'Mohamed Hakim',
        avatar: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-tx1.webp?v=1760150890&width=1920',
        videoUrl: 'https://www.youtube.com/embed/uwxcLRQFAiQ',
        videoPoster: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-video-poster1.webp?v=1760150890&width=1920',
        description: '“I love this power kit, it’s great for gifting and so practical to use. The high-capacity power bank and 45W fast charger easily cover all my charging needs, whether I’m travelling, working, or relaxing at home.”',
        profileUrl: 'https://www.youtube.com/@techreviewer1'
      },
      {
        name: 'omardizer',
        avatar: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-tx1.webp?v=1760150890&width=1920',
        videoUrl: 'https://www.youtube.com/embed/uwxcLRQFAiQ',
        videoPoster: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-video-poster1.webp?v=1760150890&width=1920',
        description: '“I love this power kit, it’s great for gifting and so practical to use. The high-capacity power bank and 45W fast charger easily cover all my charging needs, whether I’m travelling, working, or relaxing at home.”',
        profileUrl: 'https://www.youtube.com/@techreviewer2'
      },
      {
        name: 'Mohamed Hakim',
        avatar: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-tx1.webp?v=1760150890&width=1920',
        videoUrl: 'https://www.youtube.com/embed/uwxcLRQFAiQ',
        videoPoster: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-video-poster1.webp?v=1760150890&width=1920',
        description: '“I love this power kit, it’s great for gifting and so practical to use. The high-capacity power bank and 45W fast charger easily cover all my charging needs, whether I’m travelling, working, or relaxing at home.”',
        profileUrl: 'https://www.youtube.com/@techreviewer2'
      },
      {
        name: 'Mohamed Hakim',
        avatar: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-tx1.webp?v=1760150890&width=1920',
        videoUrl: 'https://www.youtube.com/embed/uwxcLRQFAiQ',
        videoPoster: 'https://us.ugreen.com/cdn/shop/files/magflow-redman-video-poster1.webp?v=1760150890&width=1920',
        description: '“I love this power kit, it’s great for gifting and so practical to use. The high-capacity power bank and 45W fast charger easily cover all my charging needs, whether I’m travelling, working, or relaxing at home.”',
        profileUrl: 'https://www.youtube.com/@techreviewer2'
      }
    ];

    // Render influencer items
    const renderInfluencers = function(data) {
      const wrapper = document.querySelector('.ramadan-influencer-swiper .swiper-wrapper');
      if (!wrapper) return;

      const playIconSvg = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="55.8598" height="55.8598" fill="white" fill-opacity="0.2"/>
                            <path d="M34.189 26.6864C35.6585 27.4598 35.6639 28.4327 34.189 29.3071L22.7933 36.5657C21.3614 37.2873 20.3889 36.8612 20.2869 35.2997L20.2385 20.1076C20.2063 18.6692 21.4608 18.2628 22.6563 18.9525L34.189 26.6864Z" fill="white"/>
                           </svg>`;

      wrapper.innerHTML = data.map(function(item) {
        const profileLink = item.profileUrl ? ' href="' + item.profileUrl + '" target="_blank"' : '';

        return (
          '<div class="swiper-slide">' +
            '<div class="ramadan-influencer-item">' +
              '<div class="ramadan-influencer-video-img magflowOpenVideoFn" data-type="youtube" data-url="' + item.videoUrl + '">' +
                '<img src="' + item.videoPoster + '" loading="lazy">' +
                playIconSvg +
              '</div>' +
              '<div class="ramadan-influencer-content">' +
                '<div class="ramadan-influencer-header">' +
                  '<a class="ramadan-influencer-img-link"' + profileLink + '><img src="' + item.avatar + '" loading="lazy"></a>' +
                  '<a class="ramadan-influencer-name-link"' + profileLink + '><p>' + item.name + '</p></a>' +
                '</div>' +
                '<div class="ramadan-influencer-content-desc">' +
                  '<p>' + item.description + '</p>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      // 根据数据数量添加对应的类名
      const section = document.querySelector('.ramadan-influencer-section');
      if (section) {
        section.classList.remove('has-2-items', 'has-3-items', 'has-carousel');
        if (data.length === 2) {
          section.classList.add('has-2-items');
        } else if (data.length === 3) {
          section.classList.add('has-3-items');
        } else if (data.length > 3) {
          section.classList.add('has-carousel');
        }
      }
    };

    // Render influencer items if the section exists
    if (document.querySelector('.ramadan-influencer-section')) {
      renderInfluencers(influencerData);
    }

    // Koop nu Modal Logic
    const buyNowButtons = document.querySelectorAll('.ramadan-buy-now-wrapper .price-button');
    const modal = document.querySelector('.ramadan-buy-now-modal');
    const modalBody = document.querySelector('.ramadan-buy-now-modal-body');
    const modalClose = document.querySelector('.ramadan-buy-now-modal-close');

    if (modal && buyNowButtons.length > 0) {
        buyNowButtons.forEach(btn => {
            btn.addEventListener('click', function(e) {
                if (window.innerWidth > 768) return; // PC端忽略点击

                const wrapper = this.closest('.ramadan-buy-now-wrapper');
                const dropdown = wrapper.querySelector('.ramadan-buy-now-dropdown');

                if (dropdown) {
                    // Clone contents
                    modalBody.innerHTML = dropdown.innerHTML;
                    // Show modal
                    modal.classList.add('active');
                    document.body.style.overflow = 'hidden'; // prevent scroll
                }
            });
        });

        const closeModal = () => {
            modal.classList.remove('active');
            document.body.style.overflow = '';
        };

        if(modalClose) modalClose.addEventListener('click', closeModal);
        modal.addEventListener('click', function(e) {
            if (e.target === modal) closeModal();
        });
    }

    // 页面加载时，默认显示header
    // 尝试多个可能的header选择器
    const headerSection = document.querySelector('.header-section') ||
                         document.querySelector('header') ||
                         document.querySelector('.shopify-section-header') ||
                         document.querySelector('[data-section-type="header"]');

    if (headerSection) {
      headerSection.classList.add('visible');
      console.log('Header found and visible class added:', headerSection);
    } else {
      console.log('Header not found, skipping header control');
    }

    window.addEventListener('scroll', function(e) {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const navElements = document.querySelectorAll('.ramadan-nav');
        const bannerSection = document.querySelector('.ramadan-banner-section');

        // 获取banner的高度
        const bannerHeight = bannerSection ? bannerSection.offsetHeight : 960;

        navElements.forEach(function(element) {
            // 当滚动超过banner时，添加fixed类并显示ramadan-nav
            if (scrollTop >= bannerHeight) {
                element.classList.add('fixed', 'visible');
                // 隐藏header-section
                if (headerSection) {
                  headerSection.classList.remove('visible');
                }
            } else {
                element.classList.remove('fixed', 'visible');
                // 显示header-section
                if (headerSection) {
                  headerSection.classList.add('visible');
                }
            }
        });
    });

    // 导航栏点击跳转功能
    const navSpans = document.querySelectorAll('.ramadan-nav .right span[data-target]');
    navSpans.forEach(function(span) {
      span.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          // 移除所有span的active类
          navSpans.forEach(function(s) {
            s.classList.remove('active');
          });
          // 添加当前span的active类
          this.classList.add('active');

          // 计算滚动位置（考虑fixed导航栏的高度）
          const navHeight = 88; // 导航栏高度
          const targetPosition = targetSection.offsetTop - navHeight;

          // 平滑滚动到目标位置
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

      const root = document.querySelector('.ramadan-compare-section');
      if (!root) return;
      const navs = root.querySelectorAll('.ramadan-compare-tab .ramadan-compare-nav, .ramadan-tab .ramadan-nav');
      const panels = root.querySelectorAll('.ramadan-compare-panel');
      const data = {
        online: [
          {
            title: 'UGREEN Nexode Power Bank with Built-in USB-C Cable 45W 20000mAh',
            url: 'https://www.amazon.ae/UGREEN-20000mAh-Charging-Portable-Charger/dp/B0DSPVDYQ9',
            specs: [
              '15.2 x 7.1 x 2.9 cm, 468 g',
              '1x USB-C Port & 1x Built-in USB-C Cable (45W Max)',
              '1x USB-A Port (22.5W Max)',
              'Compatible with Phones, Tablets, & Earphones'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/protable55988.png?v=1765186435'
          },
          {
            title: 'UGREEN Nexode Charger with Retractable USB-C Cable 45W',
            url: 'https://www.amazon.ae/UGREEN-Charger-Adapter-Retractable-Compatible/dp/B0DNSWLKKK/',
            specs: [
              '5.3 x 5.3 x 5 cm, 304 g',
              '1 USB-C Port & 1 Retractable USB-C Cable (45W Max)',
              '1 USB-A Ports	(22.5W Max)',
              'Compatible with Phones, Tablets, & Earphones'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/charger65312.png?v=1765186435'
          },
          {
            title: 'UGREEN FineTrack Smart Finder',
            url: 'https://www.amazon.ae/UGREEN-FineTrack-Replaceable-Bluetooth-Passports/dp/B0D53RXMB1',
            specs: [
              '3.6 x 3.6 x 0.74 cm, 70 g',
              'Works with Apple Find My',
              '24-Month Battery Life (Replaceable)',
              'Built-in Buzzer & Left-Behind Reminders'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/locator45297_1.png?v=1765437972'
          },
          {
            title: 'UGREEN USB-C to USB-C PD Fast Charging Cable 60W',
            url: 'https://www.amazon.ae/dp/B07ZGBJX9Y/',
            specs: [
              '1 m',
              '480Mbps Data Transfers',
              'Nylon-Braided Cable',
              'Supports PD 3.0, Huawei FCP, and Xiaomi Fast Charge'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/cable2.png?v=1765186435'
          }
        ],
        offline: [
          {
            title: 'UGREEN Nexode Power Bank with Built-in USB-C Cable 45W 20000mAh',
            specs: [
              '15.2 x 7.1 x 2.9 cm, 468 g',
              '1x USB-C Port & 1x Built-in USB-C Cable (45W Max)',
              '1x USB-A Port (22.5W Max)',
              'Compatible with Phones, Tablets, & Earphones'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/protable55988.png?v=1765186435'
          },
          {
            title: 'UGREEN Nexode Pro Charger with Retractable USB-C Cable 45W',
            specs: [
              '5.3 x 5.3 x 5 cm, 304 g',
              '1 USB-C Port & 1 Retractable USB-C Cable (45W Max)',
              '1 USB-A Ports (22.5W Max)',
              'Compatible with Phones, Tablets, & Earphones'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/charger65823.png?v=1765186435'
          },
          {
            title: 'UGREEN FineTrack Smart Finder',
            specs: [
              '3.6 x 3.6 x 0.74 cm, 70 g',
              'Works with Apple Find My',
              '24-Month Battery Life (Replaceable)',
              'Built-in Buzzer & Left-Behind Reminders'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/locator45297_1.png?v=1765437972'
          },
          {
            title: 'UGREEN USB-C to USB-C PD Fast Charging Cable 60W',
            specs: [
              '1 m',
              '480Mbps Data Transfers',
              'Nylon-Braided Cable',
              'Supports PD 3.0, Huawei FCP, and Xiaomi Fast Charge'
            ],
            image: 'https://cdn.shopify.com/s/files/1/0785/4181/6027/files/cable1.png?v=1765186435'
          }
        ]
      };
      const renderPanel = function(panelEl, items) {
        const listEl = panelEl.querySelector('.ramadan-compare-items');
        if (!listEl) return;
        listEl.innerHTML = items.map(function(item){
          var specsHtml = item.specs.map(function(s){ return '<li>'+s+'</li>'; }).join('');
          var imgHtml = item.image ? '<img class="ramadan-compare-image" src="'+item.image+'" alt="'+item.title+'">' : '';
          
          var imageLink, titleLink;
          if (item.url) {
             imageLink = '<a href="'+item.url+'" class="ramadan-compare-item-link">'+imgHtml+'</a>';
             titleLink = '<a href="'+item.url+'" class="ramadan-compare-title-link">'+item.title+'</a>';
          } else {
             imageLink = imgHtml;
             titleLink = '<span class="ramadan-compare-title-link">'+item.title+'</span>';
          }

          return (
            '<div class="ramadan-compare-item">'+
              '<div class="ramadan-compare-item-image">'+imageLink+'</div>'+
              '<div class="ramadan-compare-message">'+
                '<div class="ramadan-compare-pro-title">'+titleLink+'</div>'+
                '<div class="ramadan-compare-pro-spec">'+
                  '<ul class="compare-des">'+specsHtml+'</ul>'+
                '</div>'+
              '</div>'+
            '</div>'
          );
        }).join('');
      };
      const updateGlider = function(activeNav) {
        const glider = root.querySelector('.ramadan-compare-glider');
        if(glider && activeNav) {
          glider.style.width = activeNav.offsetWidth + 'px';
          glider.style.left = activeNav.offsetLeft + 'px';
        }
      };

      if (panels[0]) renderPanel(panels[0], data.online);
      if (panels[1]) renderPanel(panels[1], data.offline);

      // Init glider position
      const activeNav = root.querySelector('.ramadan-compare-nav.active');
      if(activeNav) updateGlider(activeNav);

      navs.forEach(function(nav, idx){
        nav.addEventListener('click', function(){
          navs.forEach(function(n){ n.classList.remove('active'); });
          nav.classList.add('active');
          panels.forEach(function(panel,i){ panel.classList.toggle('active', i===idx); });
          updateGlider(nav);
        });
      });

    // tab切换
    document.querySelectorAll('.ramadan-nav span').forEach(function(span) {
        span.addEventListener('click', function() {
            // 移除兄弟元素的active类
            const siblings = Array.from(this.parentElement.children);
            siblings.forEach(function(sibling) {
                sibling.classList.remove('active');
            });

            // 给当前点击元素添加active类
            this.classList.add('active');

            // 找到对应的panel
            const parent = this.closest('.nexode_pro');
            const panels = parent.querySelectorAll('.panel');
            const index = siblings.indexOf(this);

            // 切换panel的active类
            panels.forEach(function(panel, i) {
                if (i === index) {
                    panel.classList.add('active');
                } else {
                    panel.classList.remove('active');
                }
            });
        });
    });

    // 场景图轮播
    const slider = new Swiper('.ramadan-scene-swiper', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      centeredSlidesBounds: true,
      grabCursor: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      navigation: {
        prevEl: '.ramadan-scene-nav-btn--prev',
        nextEl: '.ramadan-scene-nav-btn--next',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },
      on: {
        init: function() {
           const circle = document.querySelector('.ramadan-scene-nav-btn--next .progress-ring__circle');
           if(circle) {
             circle.classList.remove('animating');
           }

           try {
             if (this.autoplay && typeof this.autoplay.stop === 'function') {
               this.autoplay.stop();
             }
           } catch(e) {}

        },
        afterInit: function () {
          try {
            if (this.autoplay) {
              if (window.__ramadanSceneInView) {
                this.autoplay.start();
              } else {
                this.autoplay.stop();
              }
            }
          } catch(e) {}
        },
        imagesReady: function () {
          try {
            if (this.autoplay) {
              if (window.__ramadanSceneInView) {
                this.autoplay.start();
              } else {
                this.autoplay.stop();
              }
            }
          } catch(e) {}
        },
        resize: function () {
          try {
            if (this.autoplay) {
              if (!document.hidden && window.__ramadanSceneInView) {
                this.autoplay.start();
              } else {
                this.autoplay.stop();
              }
            }
          } catch(e) {}
        },
        slideChangeTransitionStart: function () {
           const circle = document.querySelector('.ramadan-scene-nav-btn--next .progress-ring__circle');
           if(circle) {
             circle.classList.remove('animating');
           }
        },
        slideChangeTransitionEnd: function () {
           const circle = document.querySelector('.ramadan-scene-nav-btn--next .progress-ring__circle');
           if(circle) {
             circle.classList.add('animating');
           }
        },
        slideChange: function () {
          const currentIndex = this.realIndex + 1;
          const currentEl = document.querySelector('.ramadan-scene-pagination [data-current]');
          if (currentEl) {
            currentEl.textContent = currentIndex;
          }
        }
      }
    });

    

    try {
      const sceneRoot = document.querySelector('.ramadan-scene-section');
      if (sceneRoot && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.__ramadanSceneInView = true;
              try { if (slider && slider.autoplay) slider.autoplay.start(); } catch(e) {}
              try {
                const circle = document.querySelector('.ramadan-scene-nav-btn--next .progress-ring__circle');
                if(circle) {
                  circle.classList.remove('animating');
                  void circle.offsetWidth;
                  circle.classList.add('animating');
                }
              } catch(e) {}
              if (!window.__ramadanSceneAutoPlayed) {
                try {
                  const activeSlide = slider.slides?.[slider.activeIndex] || document.querySelector('.ramadan-scene-swiper .swiper-slide-active');
                  const videoPlayer = activeSlide ? activeSlide.querySelector('ug-video-player') : null;
                  if (videoPlayer) {
                    if (typeof videoPlayer.loadVideo === 'function') videoPlayer.loadVideo();
                    if (typeof videoPlayer.mute === 'function') videoPlayer.mute();
                    if (typeof videoPlayer.playVideo === 'function') {
                      videoPlayer.playVideo();
                      setTimeout(function(){
                        try {
                          if (!videoPlayer.classList.contains('is-playing')) {
                            const iframeEl = videoPlayer.querySelector('iframe');
                            const url = window.innerWidth <= 749
                              ? videoPlayer.dataset.youtubeMobile || videoPlayer.dataset.videoMobile
                              : videoPlayer.dataset.youtubeDesktop || videoPlayer.dataset.videoDesktop;
                            if (url) {
                              const finalUrl = url.indexOf('autoplay=1') === -1 ? `${url}&autoplay=1&mute=1&playsinline=1` : url;
                              const container = videoPlayer.querySelector('.ug-video__container');
                              const posters = videoPlayer.querySelectorAll('.ug-video__poster');
                              if (container) container.style.display = 'block';
                              posters.forEach(function(p){ p.style.display = 'none'; });
                              if (iframeEl) iframeEl.src = finalUrl;
                              videoPlayer.classList.add('is-playing','is-loaded','has-started');
                            }
                          }
                        } catch(e) {}
                        window.__ramadanSceneAutoPlayed = true;
                      }, 600);
                    } else {
                      const iframeEl = videoPlayer.querySelector('iframe');
                      const url = window.innerWidth <= 749
                        ? videoPlayer.dataset.youtubeMobile || videoPlayer.dataset.videoMobile
                        : videoPlayer.dataset.youtubeDesktop || videoPlayer.dataset.videoDesktop;
                      if (url) {
                        const finalUrl = url.indexOf('autoplay=1') === -1 ? `${url}&autoplay=1&mute=1&playsinline=1` : url;
                        const container = videoPlayer.querySelector('.ug-video__container');
                        const posters = videoPlayer.querySelectorAll('.ug-video__poster');
                        if (container) container.style.display = 'block';
                        posters.forEach(p => p.style.display = 'none');
                        if (iframeEl) iframeEl.src = finalUrl;
                        videoPlayer.classList.add('is-playing','is-loaded','has-started');
                      }
                      window.__ramadanSceneAutoPlayed = true;
                    }
                  }
                } catch(e) {}
              }
            } else {
              window.__ramadanSceneInView = false;
              try { if (slider && slider.autoplay) slider.autoplay.stop(); } catch(e) {}
              try {
                const circle = document.querySelector('.ramadan-scene-nav-btn--next .progress-ring__circle');
                if(circle) {
                  circle.classList.remove('animating');
                }
              } catch(e) {}
            }
          });
        }, { threshold: 0.3 });
        io.observe(sceneRoot);
      }
    } catch(e) {}

    // Influencer swiper
    const influencerSwiperDiv = document.querySelector('.ramadan-influencer-swiper');
    if(influencerSwiperDiv){
      const hasCarousel = influencerData.length > 3;
      const influencerSwiper = new Swiper(influencerSwiperDiv, {
        slidesPerView: 'auto',
        spaceBetween: 10,  // 默认（移动端）间距10px
        rtl: (window.preMagflowData && window.preMagflowData.isSwiperResever ? true : false),
        navigation: hasCarousel ? {
          nextEl: '.ramadan-influencer-section .swiper-button-next',
          prevEl: '.ramadan-influencer-section .swiper-button-prev'
        } : false,
        breakpoints: {
          769: {
            slidesPerView: 'auto',
            spaceBetween: 20  // PC端间距20px
          }
        },
      });
    }

    // 停止并重置当前 Section 内所有视频
    const stopAllVideos = () => {
      const sectionRoot = document.querySelector('.ramadan-scene-section');
      if (!sectionRoot) return;

      const videoPlayers = sectionRoot.querySelectorAll('ug-video-player');

      videoPlayers.forEach((videoPlayer) => {
        // 优先使用组件提供的 API
        if (typeof videoPlayer.reset === 'function') {
          // 重置到初始状态，显示海报、隐藏视频
          videoPlayer.reset({ unload: true, disableAutoplay: true });
          return;
        }

        // 兜底：直接操作 DOM
        const videoElement = videoPlayer.querySelector('video');
        const iframeElement = videoPlayer.querySelector('iframe');

        if (videoElement) {
          try {
            videoElement.pause();
          } catch (e) {}
          videoElement.currentTime = 0;
        } else if (iframeElement) {
          try {
            iframeElement.contentWindow?.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              '*'
            );
          } catch (e) {}
        }

        const container = videoPlayer.querySelector('.ug-video__container');
        if (container) {
          container.style.display = 'none';
        }

        const posters = videoPlayer.querySelectorAll('.ug-video__poster');
        posters.forEach((poster) => {
          poster.style.display = '';
        });

        videoPlayer.classList.remove('is-playing', 'is-loaded', 'has-started');
      });
    };

    // Swiper slide 切换时，停止所有视频
  if (slider && typeof slider.on === 'function') {
      slider.on('slideChange', function() {
        const isFirstSlideActive = this && this.realIndex === 0;
        if (isFirstSlideActive) return;
        stopAllVideos();
        const videoSlides = document.querySelectorAll('.ramadan-scene-slide[data-video-url]');
        videoSlides.forEach((slide) => {
          if (slide.dataset.replaced === 'true') return;
          const imgSrc = slide.dataset.imgSrc || '';
          const player = slide.querySelector('ug-video-player');
          if (player) player.remove();
          if (imgSrc) {
            const imgH = (window.innerWidth <= 768 ? 375 : 400);
            slide.innerHTML = `
              <div class="ramadan-scene-image-wrap" style="position:relative;height:100%;">
                <img src="${imgSrc}" alt="" width="315" height="480" loading="lazy" style="width:100%;height:100%;object-fit:cover;">
                <div style="position:absolute;right:50%;top:50%;transform:translate(-50%,-50%);z-index:2;">
                  <button class="ug-video__play-button ramadan-scene-play-btn" aria-label="Watch Video" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="inherit">
                      <path d="M16.2666 11.2916C17.2427 11.7992 17.2462 12.4378 16.2666 13.0118L8.69734 17.7764C7.74627 18.2501 7.10033 17.9704 7.03252 16.9454L7.0004 6.97321C6.97899 6.02903 7.81229 5.76227 8.60633 6.21496L16.2666 11.2916Z" stroke="inherit" stroke-width="1.5"/>
                    </svg>
                  </button>
                </div>
              </div>`;
          }
          slide.dataset.replaced = 'true';
        });
        if (typeof bindScenePlayButtons === 'function') bindScenePlayButtons();
      });
  }

    // 绑定每个卡片右上角播放按钮，触发对应视频播放
    const videoModal = document.querySelector('.ramadan-scene-video-modal');
    const videoIframe = document.querySelector('.ramadan-scene-video-iframe');
    const videoClose = document.querySelector('.ramadan-scene-video-close');
    const videoBackdrop = document.querySelector('.ramadan-scene-video-backdrop');

    const openVideoModal = (url) => {
      if (!videoModal || !videoIframe) return;
      videoIframe.src = url;
      videoModal.style.display = 'block';
      videoModal.setAttribute('aria-hidden', 'false');
      try {
        if (slider && slider.autoplay) slider.autoplay.stop();
        const scrollbarComp = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        if (scrollbarComp > 0) {
          const currentPR = parseInt(getComputedStyle(document.body).paddingRight || '0', 10) || 0;
          document.body.dataset.prevPaddingRight = String(currentPR);
          document.body.style.paddingRight = `${currentPR + scrollbarComp}px`;
        }
      } catch (e) {}
    };

    const closeVideoModal = () => {
      if (!videoModal || !videoIframe) return;
      videoIframe.src = '';
      videoModal.style.display = 'none';
      videoModal.setAttribute('aria-hidden', 'true');
      try {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        const prevPR = parseInt(document.body.dataset.prevPaddingRight || '0', 10) || 0;
        document.body.style.paddingRight = prevPR ? `${prevPR}px` : '';
        document.body.dataset.prevPaddingRight = '';
        if (slider && slider.autoplay) slider.autoplay.start();
      } catch (e) {}
    };

    if (videoClose) {
      videoClose.addEventListener('click', closeVideoModal);
    }
    if (videoBackdrop) {
      videoBackdrop.addEventListener('click', closeVideoModal);
    }

    function bindScenePlayButtons() {
      const buttons = document.querySelectorAll('.ramadan-scene-play-btn');
      buttons.forEach((button) => {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          stopAllVideos();

          const videoPlayer = button.closest('ug-video-player');
          let url = '';
          if (videoPlayer) {
            url = window.innerWidth <= 749
              ? videoPlayer.dataset.youtubeMobile || videoPlayer.dataset.videoMobile
              : videoPlayer.dataset.youtubeDesktop || videoPlayer.dataset.videoDesktop;
          } else {
            const slide = button.closest('.ramadan-scene-slide');
            url = slide?.dataset?.videoUrl || '';
          }

          const finalUrl = url && url.indexOf('autoplay=1') === -1 ? `${url}&autoplay=1&mute=1` : url;
          if (finalUrl) openVideoModal(finalUrl);
        });
      });
    }

    bindScenePlayButtons();

    // 订阅表单提交处理
    const subscribeForm = document.querySelector('.ramadan-subscribe-form');
    if (subscribeForm) {
      const emailInput = subscribeForm.querySelector('.ramadan-subscribe-input');
      const checkboxInput = subscribeForm.querySelector('.ramadan-checkbox-input');
      const submitBtn = subscribeForm.querySelector('.ramadan-subscribe-btn');
      const successMsg = subscribeForm.querySelector('.ramadan-message-success');
      const errorMsg = subscribeForm.querySelector('.ramadan-message-error');

      subscribeForm.addEventListener('submit', function(e) {
        e.preventDefault();

        // 防止重复提交
        if (submitBtn.classList.contains('loading')) {
          return false;
        }

        // 清空之前的消息并隐藏
        successMsg.innerHTML = '';
        successMsg.style.display = 'none';
        errorMsg.innerHTML = '';
        errorMsg.style.display = 'none';

        // 验证邮箱
        if (!emailInput.value || !emailInput.value.trim()) {
          errorMsg.innerHTML = 'Please enter your email address.';
          errorMsg.style.display = 'block';
          return false;
        }

        // 验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailInput.value)) {
          errorMsg.innerHTML = 'Please enter a valid email address.';
          errorMsg.style.display = 'block';
          return false;
        }

        // 验证是否同意条款
        if (!checkboxInput.checked) {
          errorMsg.innerHTML = 'Please agree to the Terms of Use and Privacy Policy.';
          errorMsg.style.display = 'block';
          return false;
        }

        // 添加loading状态
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        // 提交表单
        fetch('https://ecf.cirkleinc.com/api/form-submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: emailInput.value.trim(),
            accepts_marketing: checkboxInput.checked ? 'on' : 'off',
            form_id: '6da967cb-05b8-4bea-95f4-3d59d566075a',
            tag: 'ramadan-2025'
          }),
        })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'success') {
            emailInput.value = '';
            checkboxInput.checked = false;
            successMsg.innerHTML = 'Thank you for subscribing!';
            successMsg.style.display = 'block';

            if (window.ugGa4Track) {
              window.ugGa4Track.subscriptionEvent({
                isSuccess: true,
                position: 'ramadan-banner',
              });
            }
          } else {
            errorMsg.innerHTML = data?.errors?.email?.[0] || data.message || 'Something went wrong. Please try again.';
            errorMsg.style.display = 'block';

            if (window.ugGa4Track) {
              window.ugGa4Track.subscriptionEvent({
                isSuccess: false,
                position: 'ramadan-banner',
              });
            }
          }

          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Subscribe';
        })
        .catch((error) => {
          errorMsg.innerHTML = 'Network error. Please try again later.';
          errorMsg.style.display = 'block';
          console.error('Subscription Error:', error);

          if (window.ugGa4Track) {
            window.ugGa4Track.subscriptionEvent({
              isSuccess: false,
              position: 'ramadan-banner',
            });
          }

          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Subscribe';
        });
      });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ug-main-collection"]) return;
  try {
    
  // URL 锚点跳转至指定产品卡
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
